module.exports = new __parcel__URL__("NavLogo.286f0235.svg").toString();